import React, { createContext, useContext, useCallback } from "react";
import { message } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  WarningOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

import "./StatusContext.css";

const StatusContext = createContext(null);

export const StatusProvider = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const getIcon = (type) => {
    switch (type) {
      case "success":
        return <CheckCircleOutlined />;
      case "error":
        return <CloseCircleOutlined />;
      case "warning":
        return <WarningOutlined />;
      default:
        return <InfoCircleOutlined />;
    }
  };

  const showStatus = useCallback(({ type = "success", content = "", duration = 5 }) => {
    if (!content) return;
    messageApi.open({ type, content, duration, className: "got-message", icon: getIcon(type) });
  }, [messageApi]);

  return (
    <StatusContext.Provider value={{ showStatus }}>
      {contextHolder}
      {children}
    </StatusContext.Provider>
  );
};

export const useStatus = () => {
  const ctx = useContext(StatusContext);
  if (!ctx) throw new Error("useStatus must be used within a StatusProvider");
  return ctx;
};

export default StatusContext;
